/* js/components/Hamburger.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	toggle_class
} from "svelte/internal";

import { createEventDispatcher } from 'svelte';

function create_fragment(ctx) {
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			button.innerHTML = `<svg width="28" height="24" class="svelte-h8w5hi"><line id="top" x1="0" y1="2" x2="32" y2="2" class="svelte-h8w5hi"></line><line id="middle" x1="0" y1="12" x2="32" y2="12" class="svelte-h8w5hi"></line><line id="bottom" x1="0" y1="22" x2="32" y2="22" class="svelte-h8w5hi"></line></svg>`;
			attr(button, "class", "cursor-pointer svelte-h8w5hi");
			toggle_class(button, "open", /*open*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (!mounted) {
				dispose = listen(button, "click", /*onClick*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*open*/ 1) {
				toggle_class(button, "open", /*open*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { open = false } = $$props;
	const dispatchEvent = createEventDispatcher();

	function onClick() {
		$$invalidate(0, open = !open);
		dispatchEvent('click', { isOpen: open });
	}

	$$self.$$set = $$props => {
		if ('open' in $$props) $$invalidate(0, open = $$props.open);
	};

	return [open, onClick];
}

class Hamburger extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { open: 0 });
	}
}

export default Hamburger;